<script>
    export default {
        name: 'ArrowIcon',
        props: {
            width: {
                type: [Number, String],
                required: false,
                default: 24,
            },
            height: {
                type: [Number, String],
                required: false,
                default: 24,
            },
            rotate: {
                type: Number,
                required: false,
                default: 0,
            },
        },
        computed: {
            rotateProperty() {
                return `rotate(${this.rotate} ${this.width / 2} ${this.height / 2})`;
            },
        },
    };
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" class="fill-current" viewBox="0 0 24 24">
        <g :transform="rotateProperty">
            <path
                d="M18.59 13H3a1 1 0 010-2h15.59l-5.3-5.3a1 1 0 111.42-1.4l7 7a1 1 0 010 1.4l-7 7a1 1 0 01-1.42-1.4l5.3-5.3z" />
        </g>
    </svg>
</template>
